/**
 * Return the number of truthy values in array
 *
 * @return {Number}
 */
const countTruthy = arr => arr.filter(Boolean).length

export default countTruthy
